import { useTranslation } from 'react-i18next';
import { Box, Flex } from 'reflexbox';

import { useLocalize, useWorkspaceConfiguration } from '@treams/treams-hooks';
import * as graphql from '@treams/treams-network';
import {
	Button,
	CircleCheckmarkIcon,
	Paragraph,
	QuillText,
	Title,
	tokens,
} from '@treams/treams-ui';

export default function EngagementThankYou(props: { endPage?: graphql.LocalizedAttributedString }) {
	const { t } = useTranslation();
	const { localize } = useLocalize();
	const workspace = useWorkspaceConfiguration();

	const isEngagementPlan = workspace.data?.plans.every((plan) => plan.type === 'ENGAGE');
	const endPage = localize(props.endPage?.filter((item) => !QuillText.isEmpty(item.text)))?.text;
	const hasEndPage = !QuillText.isEmpty(endPage);

	return (
		<Flex
			alignItems="center"
			pt={5}
			justifyContent="center"
			textAlign="center"
			maxWidth={670}
			flexDirection="column"
		>
			<Box mt={4} mb={4}>
				<CircleCheckmarkIcon size={56} solid color={tokens.success.icon} aria-hidden />
			</Box>
			{hasEndPage ? (
				<Box mb={4}>
					<QuillText value={endPage} />
				</Box>
			) : (
				<>
					<Title mb={3}>{t('engagement.respond.thankYou.title')}</Title>
					<Paragraph large mb={4}>
						{t('engagement.respond.thankYou.description')}
					</Paragraph>
					{!isEngagementPlan && (
						<Button title={t('engagement.respond.thankYou.continue')} link="/" />
					)}
				</>
			)}
		</Flex>
	);
}
